import { useSelector } from "react-redux";
import ProductTiles from "../../../presentational/customerItems/ProductTiles";
import {
  getSavedItems,
  getUserIsAuthenticated
} from "../../../../state/selectors";
import {
  getShouldShowNotificationsOptIn,
  getNotificationsOptInBucket
} from "../../../../state/modules/savedItems/selectors";

const ProductTilesContainer = props => {
  const savedItems = useSelector(getSavedItems);
  const isAuthenticated = useSelector(getUserIsAuthenticated);
  const shouldShowNotificationsOptIn = useSelector(
    getShouldShowNotificationsOptIn
  );
  const bucket = useSelector(getNotificationsOptInBucket);
  const showNotificationsOptInTile =
    shouldShowNotificationsOptIn && bucket === "tile";

  return (
    <ProductTiles
      {...{ ...props, savedItems, isAuthenticated, showNotificationsOptInTile }}
    />
  );
};

export default ProductTilesContainer;
